import { TranslationsType } from "@/app/translations/Translations";

export const T_Pro: TranslationsType = {
  PATIENTS: {
    EN_US: "Patients",
    FR_FR: "Patients",
  },
  ADD_PATIENT: {
    EN_US: "Add patient",
    FR_FR: "Ajouter un patient",
  },
  LIBRARY: {
    EN_US: "3D Library",
    FR_FR: "Bibliothèque 3D",
  },
  INSOLE_MODELS: {
    EN_US: "Insole Models",
    FR_FR: "Modèles de semelles",
  },
  ADD_INSOLE_MODEL: {
    EN_US: "Add model",
    FR_FR: "Ajouter un modèle",
  },
  PROFESSION_ORTHOPEDISTE_ORTHESISTE: {
    EN_US: "Orthopaedist-orthotist",
    FR_FR: "Orthopédiste-orthésiste",
  },
  PROFESSION_PODO_ORTHESISTE: {
    EN_US: "Podo-orthotist",
    FR_FR: "Podo-orthésiste",
  },
  PROFESSION_ORTHOPROTHESISTE: {
    EN_US: "Orthopaedic prosthetist",
    FR_FR: "Orthoprothésiste",
  },
  EDIT_PATIENT: {
    EN_US: "Edit patient",
    FR_FR: "Modifier le patient",
  },
  PATIENT_ADDED: {
    EN_US: "Patient added",
    FR_FR: "Patient ajouté",
  },
  PATIENT_DELETED: {
    EN_US: "Patient deleted",
    FR_FR: "Patient supprimé",
  },
  DELETE_PATIENT: {
    EN_US: "Delete patient",
    FR_FR: "Supprimer le patient",
  },
  PATIENT_BIRTH_DATE: {
    EN_US: "Date of birth",
    FR_FR: "Date de naissance",
  },
  PATIENT_SIZE_EU: {
    EN_US: "Shoe size (EU)",
    FR_FR: "Pointure (EU)",
  },
  PATIENT_SIZE_MM: {
    EN_US: "Foot size (mm)",
    FR_FR: "Taille (mm)",
  },
  PATIENT_WEIGHT: {
    EN_US: "Weight (kg)",
    FR_FR: "Poids (kg)",
  },
  PATIENT_NOTES: {
    EN_US: "Notes",
    FR_FR: "Notes",
  },
  PATIENT_MEASUREMENTS: {
    EN_US: "Measurements",
    FR_FR: "Mensurations",
  },
  PATIENT_NO_DATA: {
    EN_US: "No data",
    FR_FR: "Non renseigné",
  },
  PATIENTS_RECENT: {
    EN_US: "Last 30 days",
    FR_FR: "30 derniers jours",
  },
  PATIENTS_EMPTY: {
    EN_US: "You have no patients yet.\nAdd your first patient to get started.",
    FR_FR: "Vous n'avez pas encore de patients.\nAjoutez votre premier patient pour commencer.",
  },
  PATIENT_NO_PRACTITIONER_TITLE: {
    EN_US: "Practitioner profile required",
    FR_FR: "Profil praticien requis",
  },
  PATIENT_NO_PRACTITIONER_TEXT: {
    EN_US: "To add patients, you must first fill in your practitioner profile.",
    FR_FR: "Pour ajouter des patients, vous devez d'abord renseigner votre profil praticien.",
  },
  PATIENT_NO_PRACTITIONER_ACTION: {
    EN_US: "Configure my profile",
    FR_FR: "Configurer mon profil",
  },
  INSOLE_MODELS_EMPTY: {
    EN_US: "No insole models yet.\nAdd your first model to get started.",
    FR_FR: "Aucun modèle de semelle.\nAjoutez votre premier modèle pour commencer.",
  },
  INSOLE_MODEL_SIDE_LEFT: {
    EN_US: "Left",
    FR_FR: "Gauche",
  },
  INSOLE_MODEL_SIDE_RIGHT: {
    EN_US: "Right",
    FR_FR: "Droit",
  },
  INSOLE_MODEL_PUBLIC: {
    EN_US: "KLIQ",
    FR_FR: "KLIQ",
  },
  INSOLE_MODEL_PERSONAL: {
    EN_US: "Personal",
    FR_FR: "Personnel",
  },
  INSOLE_MODEL_NAME: {
    EN_US: "Model name",
    FR_FR: "Nom du modèle",
  },
  INSOLE_MODEL_SIDE: {
    EN_US: "Side",
    FR_FR: "Côté",
  },
  INSOLE_MODEL_VISIBILITY: {
    EN_US: "Visibility",
    FR_FR: "Visibilité",
  },
  INSOLE_MODEL_FILE: {
    EN_US: "STL file",
    FR_FR: "Fichier STL",
  },
  INSOLE_MODEL_FILE_HINT: {
    EN_US: "STL file, up to 20 MB.",
    FR_FR: "Fichier STL, jusqu'à 20 Mo.",
  },
  INSOLE_MODEL_FILE_SELECT: {
    EN_US: "Choose a file",
    FR_FR: "Choisir un fichier",
  },
  INSOLE_MODEL_PREVIEW: {
    EN_US: "Preview image",
    FR_FR: "Image de preview",
  },
  INSOLE_MODEL_PREVIEW_HINT: {
    EN_US: "Optional image (PNG, JPG, WEBP), up to 5 MB.",
    FR_FR: "Image optionnelle (PNG, JPG, WEBP), jusqu'à 5 Mo.",
  },
  INSOLE_MODEL_PREVIEW_SELECT: {
    EN_US: "Choose an image",
    FR_FR: "Choisir une image",
  },
  INSOLE_MODEL_FILE_REPLACE: {
    EN_US: "Replace the file",
    FR_FR: "Remplacer le fichier",
  },
  EDIT_INSOLE_MODEL: {
    EN_US: "Edit model",
    FR_FR: "Modifier le modèle",
  },
  DELETE_INSOLE_MODEL: {
    EN_US: "Delete model",
    FR_FR: "Supprimer le modèle",
  },
  CONFIRM_DELETE_INSOLE_MODEL: {
    EN_US: "This insole model will be permanently deleted.",
    FR_FR: "Ce modèle de semelle sera définitivement supprimé.",
  },
  CONFIRM_DELETE_PATIENT: {
    EN_US: "This patient and all their data will be permanently deleted.",
    FR_FR: "Ce patient et toutes ses données seront définitivement supprimés.",
  },
  INSOLE_PAIRS_EMPTY: {
    EN_US: "No insole pair configured for this patient yet.",
    FR_FR: "Aucune paire de semelles configurée pour ce patient.",
  },
  CHOOSE_INSOLE_MODEL: {
    EN_US: "Choose a model",
    FR_FR: "Choisir un modèle",
  },
  NO_INSOLE_MODEL_AVAILABLE: {
    EN_US: "No insole model available.",
    FR_FR: "Aucun modèle de semelle disponible.",
  },
  PATIENT_DETAILS: {
    EN_US: "Patient details",
    FR_FR: "Détails du patient",
  },
  BACK_TO_PATIENTS: {
    EN_US: "Back to patients",
    FR_FR: "Retour aux patients",
  },
  BACK_TO_LIBRARY: {
    EN_US: "Back to library",
    FR_FR: "Retour à la bibliothèque",
  },
  INSOLES: {
    EN_US: "Insoles",
    FR_FR: "Semelles",
  },
  ADD_INSOLE_PAIR: {
    EN_US: "Add a pair",
    FR_FR: "Ajouter une paire",
  },
  INSOLE_PAIR_NAME: {
    EN_US: "Pair name",
    FR_FR: "Nom de la paire",
  },
  INSOLE_PAIR_NOTES: {
    EN_US: "Notes",
    FR_FR: "Notes",
  },
  EDIT_INSOLE_PAIR: {
    EN_US: "Rename the pair",
    FR_FR: "Renommer la paire",
  },
  DELETE_INSOLE_PAIR: {
    EN_US: "Delete the pair",
    FR_FR: "Supprimer la paire",
  },
  CONFIRM_DELETE_INSOLE_PAIR: {
    EN_US: "This insole pair will be permanently deleted.",
    FR_FR: "Cette paire de semelles sera définitivement supprimée.",
  },
  OPEN_CONFIGURATOR: {
    EN_US: "Open the configurator",
    FR_FR: "Ouvrir le configurateur",
  },
  CONFIGURE: {
    EN_US: "Configure",
    FR_FR: "Configurer",
  },
  FOOT_LEFT: {
    EN_US: "Left foot",
    FR_FR: "Pied gauche",
  },
  FOOT_RIGHT: {
    EN_US: "Right foot",
    FR_FR: "Pied droit",
  },
  VIEW_TOP: {
    EN_US: "Top",
    FR_FR: "Dessus",
  },
  VIEW_BOTTOM: {
    EN_US: "Bottom",
    FR_FR: "Dessous",
  },
  VIEW_LEFT: {
    EN_US: "Left",
    FR_FR: "Gauche",
  },
  VIEW_RIGHT: {
    EN_US: "Right",
    FR_FR: "Droite",
  },
  VIEW_FRONT: {
    EN_US: "Front",
    FR_FR: "Devant",
  },
  VIEW_BACK: {
    EN_US: "Back",
    FR_FR: "Derrière",
  },
  ZONE_TOP: {
    EN_US: "Plantar support",
    FR_FR: "Appui plantaire",
  },
  ZONE_BASE: {
    EN_US: "Ground support",
    FR_FR: "Appui au sol",
  },
  VARUS_VALGUS: {
    EN_US: "Varus / Valgus",
    FR_FR: "Varus / Valgus",
  },
  TALONNETTE: {
    EN_US: "Heel raise",
    FR_FR: "Talonnette",
  },
  ZONE_FRONT_HEIGHT: {
    EN_US: "Front",
    FR_FR: "Avant",
  },
  ZONE_BACK_HEIGHT: {
    EN_US: "Back",
    FR_FR: "Arrière",
  },
  TILT_FRONT_BACK: {
    EN_US: "Front/back",
    FR_FR: "Avant/arrière",
  },
  TILT_MEDIO_LATERAL: {
    EN_US: "Medio-lateral",
    FR_FR: "Médio-latéral",
  },
  CORRECTION: {
    EN_US: "Correction",
    FR_FR: "Correction",
  },
  DIMENSIONS: {
    EN_US: "Dimensions",
    FR_FR: "Dimensions",
  },
  POSITION: {
    EN_US: "Position",
    FR_FR: "Position",
  },
  ROTATION: {
    EN_US: "Rotation",
    FR_FR: "Rotation",
  },
  CONFIRM_RESET_CONFIGURATOR: {
    EN_US: "All adjustments for this foot will be deleted. Do you want to reset?",
    FR_FR: "Tous les ajustements de ce pied seront supprimés. Voulez-vous réinitialiser ?",
  },
  ADD_ZONE: {
    EN_US: "Add a zone",
    FR_FR: "Ajouter une zone",
  },
  ZONE_NAME: {
    EN_US: "Zone name",
    FR_FR: "Nom de la zone",
  },
  ZONES: {
    EN_US: "Zones",
    FR_FR: "Zones",
  },
  ZONE_PRESETS: {
    EN_US: "Presets",
    FR_FR: "Types prédéfinis",
  },
  ZONE_CUSTOM: {
    EN_US: "Custom zone",
    FR_FR: "Zone personnalisée",
  },
  ZONE_PRESETS_EMPTY: {
    EN_US: "No saved type yet. Configure a zone and save it as a type to reuse it.",
    FR_FR:
      "Aucun type enregistré. Configurez une zone puis enregistrez-la comme type pour la réutiliser.",
  },
  ZONE_PRESETS_GLOBAL: {
    EN_US: "KLIQ types",
    FR_FR: "Types KLIQ",
  },
  ZONE_PRESETS_MINE: {
    EN_US: "My types",
    FR_FR: "Mes types",
  },
  SAVE_AS_PRESET: {
    EN_US: "Save as reusable type",
    FR_FR: "Enregistrer comme type réutilisable",
  },
  DELETE_ZONE_PRESET: {
    EN_US: "Delete the type",
    FR_FR: "Supprimer le type",
  },
  ZONE_SHAPE: {
    EN_US: "Shape",
    FR_FR: "Forme",
  },
  ZONE_PROFILE: {
    EN_US: "Profile",
    FR_FR: "Profil",
  },
  ZONE_KIND_BUMP: {
    EN_US: "Relief",
    FR_FR: "Relief",
  },
  ZONE_KIND_CUP: {
    EN_US: "Cup",
    FR_FR: "Cuvette",
  },
  ZONE_KIND_WEDGE: {
    EN_US: "Wedge",
    FR_FR: "Biseau",
  },
  ZONE_ANGLE: {
    EN_US: "Angle",
    FR_FR: "Angle",
  },
  ZONE_AREA: {
    EN_US: "Zone",
    FR_FR: "Zone",
  },
  DELETE_ZONE: {
    EN_US: "Delete the zone",
    FR_FR: "Supprimer la zone",
  },
  DIMENSION_WIDTH: {
    EN_US: "Width",
    FR_FR: "Largeur",
  },
  DIMENSION_LENGTH: {
    EN_US: "Length",
    FR_FR: "Longueur",
  },
  DIMENSION_HEIGHT: {
    EN_US: "Height",
    FR_FR: "Hauteur",
  },
  PATIENT_GENDER: {
    EN_US: "Gender",
    FR_FR: "Sexe",
  },
  PATIENT_GENDER_MALE: {
    EN_US: "Male",
    FR_FR: "Homme",
  },
  PATIENT_GENDER_FEMALE: {
    EN_US: "Female",
    FR_FR: "Femme",
  },
  PATIENT_GENDER_OTHER: {
    EN_US: "Other",
    FR_FR: "Autre",
  },
};
